import React, { useState, useEffect } from "react";
import { Outlet, Navigate } from "react-router-dom";
import SideBar from "../component/sidebar";
import Navbar from "../component/Navbar";
import { Helmet } from "react-helmet";

const ProtectedRoute = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [activeTab, setActiveTab] = useState("dashboard");
  const [notifications, setNotifications] = useState([]);

  // Simulated authentication check
  const jwt = localStorage.getItem("driverToken");
  if (!jwt) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="flex h-screen">
      {/* SEO Metadata for Driver Portal */}
      <Helmet>
        <title>AfricFresh | Driver Portal - Delivery Management System</title>
        <meta 
          name="description" 
          content="AfricFresh Driver Portal - Manage your deliveries, view earnings, and track performance. Our driver management system helps you efficiently complete deliveries across Africa." 
        />
        <meta name="keywords" content="AfricFresh driver, delivery portal, driver dashboard, delivery management, AfricFresh courier, driver earnings" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://africfresh.onrender.com/driver" />
        <meta property="og:title" content="AfricFresh | Driver Portal - Delivery Management System" />
        <meta property="og:description" content="Manage your deliveries, view earnings, and track performance with AfricFresh Driver Portal" />
        <meta property="og:image" content="https://africfresh.onrender.com/static/media/logo1.74d76b453ee033b85ec4.jpg" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://africfresh.onrender.com/driver" />
        <meta name="twitter:title" content="AfricFresh | Driver Portal - Delivery Management System" />
        <meta name="twitter:description" content="Manage your deliveries, view earnings, and track performance with AfricFresh Driver Portal" />
        <meta name="twitter:image" content="https://africfresh.onrender.com/static/media/logo1.74d76b453ee033b85ec4.jpg" />

        {/* Canonical URL */}
        <link rel="canonical" href="https://africfresh.onrender.com/driver" />
      </Helmet>

      {/* Sidebar */}
      <SideBar
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />

      {/* Main content */}
      <div className="flex flex-col flex-1 pl-64">
        <Navbar
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
          notifications={notifications}
        />
        <main className="p-6 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default ProtectedRoute;